import { Box, CircularProgress, Paper } from "@mui/material";
import {useDropzone} from 'react-dropzone'
import { myConstants } from "../../shares/Constants";
import React, { useMemo} from 'react';
import { useUpdateClubLogoMutation } from "../../store/club/ClubApi";

export const dropZoneWidth   = 240;
export const dropZoneHeight  = 300;

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  //padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor:"rgba(0, 0, 0, 0)",
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  width:'100%',
  height:'100%',
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


/* 
 Das eigentliche (veränderte) Dropzone
 Objekt, welches auf die Eingabe wartet.
 Dieses hinterlegen wir mit dem aktuellen
 Bild, damit wir dieses direkt anzeigen können. 
 Sobald jemand die Dropzone verwenden, schalten
 wir dann das Bild um. 
*/
function StyledDropzone({year, club, props}) {
  
  // Senden der Datei berücksichtigen...
  const [updateClubLogo] = useUpdateClubLogoMutation();
  // const [clubLogo, setClubLogo] = React.useState(myConstants.baseURL + club.logo);
  const [clubLogo, setClubLogo] = React.useState(myConstants.baseURL.replace(/\/$/, '') + club.logo);



  // Aufbauen des reagierens auf abgelegte Dateien
  const onDropAccepted = React.useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach(
        file => 
        {
          console.log(file);
          // wir bereiten die Form-Daten vor, damit danach
          // die Datei hochgeladen werden kann:
          updateClubLogo( 
            { tournament_id: year, club_id : club.id, file : file }
          ).unwrap(            
          ).then(  
           (payload) => setClubLogo(myConstants.baseURL.replace(/\/$/, '') + payload.logo)                     
          ).catch(
            (error) => console.error(error)
          );
        }
      );    
    }, [year, club.id, updateClubLogo, setClubLogo]
  );


  // Aufbauen der eigentlichen Dropzone
  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone(
    {
      multiple: false, 

      accept: 
      {
        'image/jpeg': [],
        'image/png': []
      },
      useFsAccessApi: false,
      onDropAccepted: onDropAccepted,
    }
  );

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);



  // Größe des Bildes ermitteln - sollte es Höher als Breit sein, 
  // dann wechseln wir die Rendergröße  
  const [backgroundSize, setBackgroundSize] = React.useState("");

  // Einmalig im Hintergurnd ermitteln...
  React.useEffect( () => 
    {
      let img = new Image();
      img.src = clubLogo;
      img.onload = () => 
      {
        if (img.height > dropZoneHeight)
          if (img.width > dropZoneWidth)
            if (img.width > img.height)
              setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
            else
              setBackgroundSize("auto " + String(dropZoneHeight).toString() + "px");
          else
            setBackgroundSize("auto " + String(dropZoneHeight).toString() + "px");          
        else
          if (img.width > dropZoneWidth) 
            setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
          else
            if (img.width > img.height)
              setBackgroundSize(String(dropZoneWidth).toString() + "px auto");
            else
              setBackgroundSize("auto " + String(dropZoneHeight).toString() + "");
      } 
    }, [clubLogo, setBackgroundSize]
  );

  

  return (
    <Box 
      className="container" 
      sx={{
        height:`${dropZoneHeight}px`, 
        backgroundImage:`url(${clubLogo})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",        
        backgroundSize: `${backgroundSize}`,
        //backgroundSize: "240px auto",
      }} >
      <div {...getRootProps({style})} sx={{
        background: 'transparent',
        border: "none",}}>
        <input {...getInputProps()} sx={{
          background: 'transparent',
        }}/>
      </div>
    </Box>
  );
}

export function Logo({year, club})
{

  if (!club)
  {
    return( <CircularProgress /> );
  }
  else
  {
    return(
      <Paper>        
        <StyledDropzone key={club.id} year={year} club={club} />
      </Paper>
    );
  }

}